import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { appActions } from '../store/ducks/app';
import { Button, Small, Center, Column, Link } from './styled';
import { LoaderSmall } from '.';
import { GroupTypesB2C, Period, Status } from '../helpers/product';
import { formatDate, resolveTextWithLinks } from '../helpers/util';
import { modalActions } from '../store/ducks/modal';
import { BoxInfo, BoxInfoTitle } from './styled/Box';

interface State {
  agreementChecked: boolean;
}
interface OwnProps {
  intl?: any;
}

const mapStateToProps = (state: any) => ({
  prescription: state.appData.prescription,
  language: state.appData.language,
  subscription: state.appData.subscription,
  agreementError: state.appData.payment.agreementError,
  general: state.appData.general,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  switchError: (errorName: string, error: boolean) => void;
  toggleDowngradeSubscriptionModal: (isOpen: boolean) => void;
  toggleCancelSubscriptionModal: (isOpen: boolean) => void;
  toggleChangePeriodModal: (isOpen: boolean) => void;
  startEnableSubscription: (period: Period, agreement: boolean) => void;
}

type Props = OwnProps & StateProps & DispatchProps;

class InfoBox extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      agreementChecked: false,
    };
  }

  switchAgreement = () => {
    this.setState({ agreementChecked: !this.state.agreementChecked });
    this.props.switchError('agreementError', false);
  };

  getInfoTitleText = (groupType: GroupTypesB2C, active: boolean) => {
    if (groupType === GroupTypesB2C.FREE_TRIAL) {
      return 'your_free_trial_will_expire_on';
    }
    return active ? 'next_billing_on' : 'your_subscription_will_expire_on';
  };

  getResolvedInfoBoxDescription = (groupType: GroupTypesB2C, active: boolean) => {
    if (groupType === GroupTypesB2C.FREE_TRIAL) {
      return 'enrolled_free_trial';
    }
    return active ? `enrolled_${groupType.toLowerCase()}` : `${groupType.toLowerCase()}_enable_auto_renewal_description`;
  };

  render() {
    const { subscription, prescription } = this.props;
    const active = subscription?.status === Status.ACTIVE;
    const noFreeTrial = prescription?.type !== GroupTypesB2C.FREE_TRIAL;
    if (!this.props.general) {
      return <BoxInfo><LoaderSmall /></BoxInfo>;
    }
    return (
      <BoxInfo>
        <BoxInfoTitle active={active}>
          <FormattedMessage id={this.getInfoTitleText(prescription.type, active)} />
          { ` ${formatDate(prescription.end)}` }
        </BoxInfoTitle>
        <Small>
          <FormattedMessage id={this.getResolvedInfoBoxDescription(prescription.type, active)} />
          {
            noFreeTrial && active && (
              <Link onClick={() => this.props.toggleCancelSubscriptionModal(true)}>
                { this.props.intl.formatMessage({ id: 'enrolled_disable_link' }) }
              </Link>
            )
          }
          <br />
          {
            active && subscription?.plan === GroupTypesB2C.PREMIUM && (
              <>
                <Link onClick={() => this.props.toggleDowngradeSubscriptionModal(true)}>
                  { this.props.intl.formatMessage({ id: 'enrolled_premium_description_downgrade' }) }
                </Link> <br />
              </>
            )
          }
          {
            noFreeTrial && active && subscription?.billingPeriod === Period.YEARLY && (
              <>
                <Link onClick={() => this.props.toggleChangePeriodModal(true)}>
                  { this.props.intl.formatMessage({ id: 'currently_on_yearly' }) }
                </Link> <br />
              </>
            )
          }
        </Small>
        {
          noFreeTrial && active && subscription?.billingPeriod === Period.MONTHLY && (
            <Center>
              <Button onClick={() => this.props.toggleChangePeriodModal(true)}>
                <FormattedMessage id={`switch_to_yearly_and_save_${prescription.type}`} />
              </Button>
            </Center>
          )
        }
        {
          noFreeTrial && !active && (
            <>
              <br />
              <Column>
                <div className="form-group">
                  <div className="form-group--checkbox">
                    <span onClick={this.switchAgreement} className={this.state.agreementChecked ? 'checkbox checkbox--active' : 'checkbox'} />
                    <Small red={this.props.agreementError}>{
                      resolveTextWithLinks(
                        this.props.intl.formatMessage({ id: 'agreement' }),
                        [`${this.props.general.config.termsOfUseLink}${this.props.language}/`,
                          `${this.props.general.config.privacyPolicyLink}${this.props.language}/`]
                      )
                    }
                    </Small>
                  </div>
                </div>
              </Column>
              <Center>
                <Button onClick={() => this.props.startEnableSubscription(Period.YEARLY, this.state.agreementChecked)}>
                  <FormattedMessage id="switch_to_yearly" />
                </Button>
              </Center>
              <Center>
                <Button onClick={() => this.props.startEnableSubscription(Period.MONTHLY, this.state.agreementChecked)}>
                  <FormattedMessage id="switch_to_monthly" />
                </Button>
              </Center>
            </>
          )
        }
      </BoxInfo>
    );
  }
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, { ...appActions, ...modalActions })(injectIntl(injectedIntl));

export function injectedIntl(props: Props) {
  return <InfoBox {...props} />;
}
